import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import moment from 'moment'
import UploadFileDrive from '@/components/view/intent/Dialog/UploadFileDrive.vue'
const imgLink = require('../../../static/img/pdf-image-placeholder.png')

export default {
  props: {
    value: null,
    height: {
      default: 250,
      type: Number
    },
    outputtype: {
      default: 'url',
      type: String
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    },
    useDrive: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: undefined
    },
    urls: {
      type: Array,
      default: undefined
    }
  },
  data: function () {
    return {
      filelength: 0,
      multiplefile: [],
      base64img: '',
      currentImage: this.value,
      loading: false,
      objId: null,
      uploadtimestamp: moment().format('x'),
      tempWidth: '',
      tempHeight: '',
      driveDialogOpen: false
    }
  },
  components: {
    SyncLoader,
    UploadFileDrive
  },
  computed: {
    showImage() {
      return /(\.pdf$)/.test(this.currentImage) ? imgLink : this.currentImage
    }
  },
  created: function () {
    if (this.value && /(\.pdf$)/.test(this.value)) {
      this.currentImage = imgLink
    }
    this.objId = Math.random()
  },
  methods: {
    onClickUploadButton: function () {
      if (!this.disabled) {
        if (this.useDrive) {
          this.driveDialogOpen = true
        } else {
          document.getElementById('photoUploadInput' + this.objId).click()
        }
      }
    },
    fileResize: function (file) {
      let vm = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function () {
          var tempImg = new Image()
          tempImg.src = reader.result
          tempImg.onload = function () {
            var MAX_WIDTH = 2000
            var MAX_HEIGHT = 2000
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            var tempW = tempImg.width
            var tempH = tempImg.height

            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }

            if (tempW != 1040) {
              tempW = parseInt(tempW)
              tempH = parseInt(tempH)
              if (tempW > tempH) {
                let radio = tempH / tempW
                tempW = 1040
                tempH = tempW * radio
              } else {
                let radio = tempH / tempW
                tempW = 1040
                tempH = tempW * radio
              }
            }
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            vm.tempWidth = tempW
            vm.tempHeight = tempH
            var canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH

            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            var dataURL = null
            if (file.type == 'image/png') {
              dataURL = canvas.toDataURL('image/png')
            } else {
              dataURL = canvas.toDataURL('image/jpeg')
            }
            var data = 'image=' + dataURL
            try {
              if (vm.outputtype == 'base64') {
                vm.$emit('input', dataURL)
                vm.currentImage = dataURL
                vm.$emit('onUploaded', dataURL)
              }
              var obj = vm.dataURItoBlob(data)
              obj.name = file.name

              resolve(obj)
            } catch (error) {
              vm.$swal({
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                type: 'error',
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t('Confirm')
              })
              reject()
            }
          }
        }
        reader.readAsDataURL(file)
      })
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function (event) {
      var vm = this
      var result = await this.$validator.validate()

      if (!result) {
        // do stuff if not valid.
        this.uploadtimestamp = moment().format('x')
        return
      } else {
        this.loading = true
        let files = event.target.files || event.dataTransfer.files

        await this.validateFile(files)
        event.target.value = ''
        this.loading = false
      }
    },
    async validateFile(files) {
      if (!files.length) {
        this.uploadtimestamp = moment().format('x')
        return
      } else {
        this.filelength = files.length
      }
      if (this.multiple) {
        for (let file of files) {
          var obj = await this.fileResize(file)
          return await this.createImage(obj)
        }
      } else {
        try {
          var obj = null
          if (files[0].type != 'image/gif') {
            obj = await this.fileResize(files[0])
          } else {
            obj = files[0]
          }
          if (!obj) throw new Error('Something went wrong')
          if (this.outputtype != 'base64') {
            return await this.createImage(obj)
          }
        } catch (error) {
          await this.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            text: `fileResize: ${error}`,
            confirmButtonText: this.$t('Confirm')
          })
        }
      }
    },
    async createImage(file) {
      try {
        return await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.$emit('input', vm.currentImage, { width: vm.tempWidth, height: vm.tempHeight })
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(vm.currentImage)
        })
      })
    },
    onRemoveImage() {
      this.currentImage = ''
      this.$emit('input', null)
      this.$emit('onUploaded', null)
    },
    async handleDriveUpload(value) {
      const urls = Array.isArray(value) ? value : [value]
      const items = (
        await Promise.all(
          urls.map(
            (url) =>
              new Promise((resolve) => {
                const img = new Image()
                img.src = url
                img.onload = () => {
                  this.tempWidth = img.naturalWidth
                  this.tempHeight = img.naturalHeight
                  this.currentImage = url
                  resolve([url, { width: this.tempWidth, height: this.tempHeight }])
                }
                img.onerror = () => {
                  resolve(undefined)
                }
              })
          )
        )
      ).filter(Boolean)

      if (this.multiple) {
        this.$emit(
          'input',
          items.map(([url]) => url),
          items.map(([, size]) => size)
        )
        this.$emit(
          'onUploaded',
          items.map(([url]) => url)
        )
        return
      }

      const [url, size] = items[0]
      this.$emit('input', url, size)
      this.$emit('onUploaded', url)
    }
  },
  watch: {
    value: function (newVal) {
      this.currentImage = newVal
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/UploadSingleFile.js